import { ArticleCommentsTopTabRenderProps } from "../articleCommentsTopTabWrapper"
import { getTranslation } from "../translations"
import { getTalkbackNumberView } from "../../articleSocialShare1280Component/articleSocialShareNew1280";


interface ArticleCommentsTopTabUI2026rops {
    props: ArticleCommentsTopTabRenderProps
}

export class ArticleCommentsTopTabMobileWebUI2026 extends React.Component<ArticleCommentsTopTabUI2026rops, {}> {
      private handleOnAddCommentBtnPress = () => {
        const { handleFormVisibility, handleCommentsPopupVisibility } = this.props.props
        handleCommentsPopupVisibility()
        handleFormVisibility()
    }
      private handleOnCommentPopupOpen = () => {
        const {  handleCommentsPopupVisibility } = this.props.props
        handleCommentsPopupVisibility()
       
    }
    render() {
        const { lang, isLtr, numOfComments, isAddCommentFormVisible } = this.props.props
        return (
            <div className="ArticleCommentsTopTabMobileUI2026">
                     <div className="tabPanel">
                        <button
                            key="newCommentBtn"
                            className="newCommentBtn"
                            title={getTranslation(lang, "New Comment")}
                            disabled={isAddCommentFormVisible}
                            onClick={this.handleOnAddCommentBtnPress}>
                            <div className="btnText">{getTranslation(lang, "New Comment(premium)")}</div>
                        </button>
                    
                </div>
                <div className="tabTitle" onClick={this.handleOnCommentPopupOpen}>
                    <span className="tbIcon" />
                    <span>{getTalkbackNumberView(numOfComments.toString())} {getTranslation(lang, "Comments")}</span>
                </div>
          
            </div >
        )
    }
}